import { Socket } from 'rete'

export const numberSocket = new Socket('Number')
export const booleanDataSocket = new Socket('Boolean dataset')

export const numericDataSocket = new Socket('Numeric dataset')

export const categoricalDataSocket = new Socket('Categorical dataset')

export const propertySocket = new Socket('Property')

// A tabular dataset (named rows + columns with a 2D array of cells). Kept
// deliberately separate from the raster `dataSocket` family — tables are not
// spatial tile grids, so they only connect to other Table sockets.
export const tableDataSocket = new Socket('Table dataset')

export const dataSocket = new Socket('Dataset')
booleanDataSocket.combineWith(dataSocket)
numericDataSocket.combineWith(dataSocket)
categoricalDataSocket.combineWith(dataSocket)

export const numericNumberDataSocket = new Socket('Number or Numeric dataset')
numberSocket.combineWith(numericNumberDataSocket)
numericDataSocket.combineWith(numericNumberDataSocket)

numericNumberDataSocket.combineWith(numberSocket)
numericNumberDataSocket.combineWith(numericDataSocket)
numericNumberDataSocket.combineWith(dataSocket)

export const CATEGORICAL_BOOLEAN_DATA_SOCKET_NAME = 'Categorical or Boolean dataset'

export const categoricalBooleanDataSocket = new Socket(CATEGORICAL_BOOLEAN_DATA_SOCKET_NAME)
booleanDataSocket.combineWith(categoricalBooleanDataSocket)
categoricalDataSocket.combineWith(categoricalBooleanDataSocket)

categoricalBooleanDataSocket.combineWith(booleanDataSocket)
categoricalBooleanDataSocket.combineWith(categoricalDataSocket)
categoricalBooleanDataSocket.combineWith(dataSocket)

export function isBooleanDatasetSocket(socket: Socket | null | undefined): boolean {
  if (!socket) return false
  if (socket === booleanDataSocket) return true
  const name = typeof (socket as Socket).name === "string" ? (socket as Socket).name : ""
  return name === booleanDataSocket.name
}

export function isCategoricalDatasetSocket(socket: Socket | null | undefined): boolean {
  if (!socket) return false
  if (socket === categoricalDataSocket) return true
  const name = typeof (socket as Socket).name === "string" ? (socket as Socket).name : ""
  return name === categoricalDataSocket.name
}

export function isCategoricalOrBooleanDatasetSocket(socket: Socket | null | undefined): boolean {
  if (!socket) return false
  return (
    isBooleanDatasetSocket(socket) ||
    isCategoricalDatasetSocket(socket) ||
    socket === categoricalBooleanDataSocket
  )
}

